var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirways(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 122.922,
    viewBox: "0 0 128 122.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M204.355,106.849l.752-22.528,0-.113c0-8.818-6.864-15.992-15.3-15.992s-15.3,7.175-15.3,15.992l.761,22.821-49.291,26.579v14.814a5.879,5.879,0,0,0,5.874,5.873h.473l44.122-12.8.851,20.911a22.18,22.18,0,0,0,.449,4.378l-15.625,9.2,0,9.906a5.262,5.262,0,0,0,5.247,5.243h.532l21.329-6.972h1.5l21.326,6.972h.53a5.247,5.247,0,0,0,5.248-5.246l0-9.9L201.9,166.61a21.9,21.9,0,0,0,.413-4.2l.855-21.009L247.635,154.3h.473a5.878,5.878,0,0,0,5.871-5.873V133.61Zm42.964,40.421-50.455-14.63-1.2,29.565,0,.135a14.817,14.817,0,0,1-.771,4.786l-.874,2.567L211.179,179.8v4.048l-19.389-6.337h-3.622l-19.387,6.339V179.8l16.9-9.953-.908-2.585a14.844,14.844,0,0,1-.817-4.924l-1.2-29.6-50.118,14.535v-9.687l49.425-26.654-.9-26.774c.026-5.122,3.893-9.281,8.642-9.281s8.615,4.158,8.642,9.281l-.889,26.594,49.759,26.836Z",
    transform: "translate(-125.979 -68.216)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirways);
export default __webpack_public_path__ + "static/media/Airways.ecadf1c99cca7aa174ed09f7087d6386.svg";
export { ForwardRef as ReactComponent };